import { render } from "./ItemErrors.vue?vue&type=template&id=36927ea9"
import script from "./ItemErrors.vue?vue&type=script&lang=js"
export * from "./ItemErrors.vue?vue&type=script&lang=js"

import "./ItemErrors.vue?vue&type=style&index=0&id=36927ea9&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__